import React from 'react'

import './style.scss'

const AboutContent = () => {
  return (
    <div className="content-box">
      <div className="about-header-bar" />
    </div>
  )
}

export default AboutContent



// WEBPACK FOOTER //
// ./src/Pages/ContentPage/Content/AboutContent.js